function DTWishlist() {    
  const LOCAL_STORAGE_WISHLIST_KEY = 'shopify-wishlist';
  const LOCAL_STORAGE_DELIMITER = ',';
  const BUTTON_ACTIVE_CLASS = 'added';
  const GRID_LOADED_CLASS = 'loaded';
  const LOADING_STATUS = 'adding';

  const selectors = {
    button: '[button-wishlist]',
    grid: '[grid-wishlist]',
    productCard: '.wishlist__grid-item',
  };

  document.addEventListener('DOMContentLoaded', () => {
    initButtons();
    initGrid();
  });

  document.addEventListener('shopify-wishlist:updated', (event) => {
    initGrid();
  });

  const fetchProductCardHTML = async (handle) => {
    const productTileTemplateUrl = `/products/${handle}?view=card`;
    try {
      const res = await fetch(productTileTemplateUrl);
      const text = await res.text();
      const parser = new DOMParser();
      const htmlDocument = parser.parseFromString(text, 'text/html');
      const productCard = htmlDocument.documentElement.querySelector(selectors.productCard);
      return productCard.outerHTML;
    } catch (err) {
      console.error(`[Shopify Wishlist] Failed to load content for handle: ${handle}`, err);
      return '';
    }
  };

  const setupGrid = async (grid) => {
    const wishlist = getWishlist();
    if (wishlist.length === 0) {
      grid.classList.add(GRID_LOADED_CLASS);
      grid.classList.add('empty-list');
      
      while (grid.firstChild) {
        grid.removeChild(grid.firstChild);
      }
      
      const emptyMessage = document.createTextNode("Your wishlist looks empty");
      grid.appendChild(emptyMessage);
      return;
    }
    
    const requests = wishlist.map(fetchProductCardHTML);
    const responses = await Promise.all(requests);
    const wishlistProductCards = responses.join('');
    const fragment = document
      .createRange()
      .createContextualFragment(wishlistProductCards);

    grid.replaceChildren(...fragment.childNodes);
    grid.classList.add(GRID_LOADED_CLASS);
    const loader = document.querySelector('.wishlist__loader');

    if (loader) {
      loader.style.display = 'none';
    }

    initButtons();

    const event = new CustomEvent('shopify-wishlist:init-product-grid', {
      detail: { wishlist: wishlist }
    });
    document.dispatchEvent(event);
  };

  const setupButtons = (buttons) => {
    buttons.forEach((button) => {
      const productHandle = button.dataset.productHandle || false;
      if (!productHandle) return console.error('[Shopify Wishlist] Missing `data-product-handle` attribute. Failed to update the wishlist.');
      if (wishlistContains(productHandle)) button.classList.add(BUTTON_ACTIVE_CLASS);
      
      // Remove existing listeners to avoid duplicates
      button.removeEventListener('click', handleButtonClick);
      button.addEventListener('click', handleButtonClick);
      
      function handleButtonClick() {
        if (button.classList.contains(LOADING_STATUS)) return; // Prevent double clicks
        button.classList.add(LOADING_STATUS);
        updateWishlist(productHandle, button);
        setTimeout(() => {
          button.classList.remove(LOADING_STATUS);
        }, 500);
      }
    });
  };

  const initGrid = () => {
    const grid = document.querySelector(selectors.grid) || false;
    if (grid) setupGrid(grid);
    wishListCount();
  };

  const initButtons = () => {
    const buttons = document.querySelectorAll(selectors.button) || [];
    if (buttons.length) setupButtons(buttons);
    
    const event = new CustomEvent('shopify-wishlist:init-buttons', {
      detail: { wishlist: getWishlist() }
    });
    document.dispatchEvent(event);
  };

  const getWishlist = () => {
    const wishlist = localStorage.getItem(LOCAL_STORAGE_WISHLIST_KEY) || false;
    if (wishlist) return wishlist.split(LOCAL_STORAGE_DELIMITER);
    return [];
  };

  const setWishlist = (array) => {
    const wishlist = array.join(LOCAL_STORAGE_DELIMITER);
    if (array.length) localStorage.setItem(LOCAL_STORAGE_WISHLIST_KEY, wishlist);
    else localStorage.removeItem(LOCAL_STORAGE_WISHLIST_KEY);

    const event = new CustomEvent('shopify-wishlist:updated', {
      detail: { wishlist: array }
    });
    document.dispatchEvent(event);

    return wishlist;
  };

  const updateWishlist = (handle, button) => {
    const wishlist = getWishlist();
    const indexInWishlist = wishlist.indexOf(handle);
    
    let newWishlist;
    if (indexInWishlist === -1) {
      // Add to wishlist
      newWishlist = [...wishlist, handle];
      button.classList.add(BUTTON_ACTIVE_CLASS);
    } else {
      // Remove from wishlist
      newWishlist = wishlist.filter(item => item !== handle);
      button.classList.remove(BUTTON_ACTIVE_CLASS);
    }
    
    // Update localStorage and dispatch event
    setWishlist(newWishlist);
    wishListCount();
  };

  const wishlistContains = (handle) => {
    const wishlist = getWishlist();
    return wishlist.includes(handle);
  };

  const resetWishlist = () => {
    return setWishlist([]);
  };

  const wishListCount = () => {
    const currentCount = getWishlist().length;
    const wishCount = document.querySelector('.wishlist-count-bubble');
    if (wishCount) {
      const span = wishCount.querySelector("span");
      if (span) span.textContent = currentCount;
    }
    
    const wishContainer = document.getElementById('wishlist');
    if (currentCount === 0) {
      document.querySelectorAll(".dtxc-wishlist-count").forEach(countBubble => { 
        countBubble.style.display = "none" 
      });
      
      if (wishContainer && wishContainer.querySelector('.wishlist__grid')) {
        const grid = wishContainer.querySelector('.wishlist__grid');
        if (grid && !grid.classList.contains(GRID_LOADED_CLASS)) {
          // Clear grid and add text node
          while (grid.firstChild) {
            grid.removeChild(grid.firstChild);
          }
          const emptyMessage = document.createTextNode("Your wishlist looks empty");
          grid.appendChild(emptyMessage);
          grid.classList.add('empty-list');
        }
      }
    } else {
      document.querySelectorAll(".dtxc-wishlist-count").forEach(countBubble => { 
        countBubble.style.display = "block" 
      });
    }

    // Update footer heart clone
    const wishlistBubble = document.getElementById('dtxc-wishlistBubble');
    const footerHeart = document.getElementById('footerHeart');
    if (wishlistBubble && footerHeart) {
      while (footerHeart.firstChild) {
        footerHeart.removeChild(footerHeart.firstChild);
      }
      const clone = wishlistBubble.cloneNode(true);    
      footerHeart.appendChild(clone);
    }
  };
  
  // Initial calls
  initButtons();
  initGrid();
}

document.addEventListener('DOMContentLoaded', () => {
  DTWishlist();
});